import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "text-primary" }
const _hoisted_2 = {
  key: 0,
  class: "pt-2"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "text-center" }
const _hoisted_6 = { class: "d-flex align-center primary--text" }
const _hoisted_7 = { class: "d-flex align-center primary--text" }
const _hoisted_8 = { class: "text-center" }
const _hoisted_9 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_AccountingPeriodIsDeletable = _resolveComponent("AccountingPeriodIsDeletable")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_oss_date_picker_filled = _resolveComponent("oss-date-picker-filled")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_btn_trash = _resolveComponent("v-btn-trash")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!
  const _component_v_tabs_window = _resolveComponent("v-tabs-window")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.mainDialog,
      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.mainDialog) = $event)),
      title: _ctx.title,
      onValid: _cache[32] || (_cache[32] = ($event: any) => (_ctx.upsert())),
      validLoading: _ctx.mainLoading,
      validDisabled: _ctx.readOnly || !_ctx.valid || _ctx.step === 'accClosing' || _ctx.mainDialogValidDisabled,
      validTitle: _ctx.validTitle,
      "hide-valid": _ctx.definitivelyClosed,
      prefixDataCy: "AccountingPeriod-closeDialog",
      width: "900px"
    }, {
      default: _withCtx(() => [
        (_ctx.errorMessage && _ctx.errorMessage.length)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.stringToArray(_ctx.errorMessage), (line) => {
              return (_openBlock(), _createElementBlock("h3", _hoisted_1, _toDisplayString(line), 1))
            }), 256))
          : _createCommentVNode("", true),
        (_ctx.showIsExceptionnalCheckBox)
          ? (_openBlock(), _createBlock(_component_v_row, {
              key: 1,
              "no-gutters": ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "auto" }, {
                  default: _withCtx(() => [
                    (
                            _ctx.accountingPeriod &&
                            (_ctx.accountingPeriod.closed ||
                                _ctx.newClosed ||
                                _ctx.accountingPeriod.temporaryClosed)
                        )
                      ? (_openBlock(), _createElementBlock("h3", _hoisted_2, "Exercice clôturé"))
                      : (
                            _ctx.accountingPeriod && _ctx.accountingClosings && _ctx.accountingClosings.length
                        )
                        ? (_openBlock(), _createElementBlock("h3", _hoisted_3, "Exercice ayant des situations intermédiaires"))
                        : (
                            _ctx.accountingPeriod &&
                            _ctx.accountingPeriod.isDeletable &&
                            _ctx.accountingPeriod.isDeletable.length
                        )
                          ? (_openBlock(), _createBlock(_component_v_tooltip, {
                              key: 2,
                              location: "top"
                            }, {
                              activator: _withCtx(({ props }) => [
                                _createElementVNode("div", _mergeProps(props, { class: "pt-2" }), [
                                  _createVNode(_component_v_checkbox, {
                                    dense: "",
                                    modelValue: _ctx.isExceptionnalChange,
                                    "onUpdate:modelValue": [
                                      _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isExceptionnalChange) = $event)),
                                      _ctx.checkBoxFunction
                                    ],
                                    label: "Changement exceptionnel : attention, des éléments basés sur les dates d'exercice ont été enregistrés : si vous validez cette modification, veillez à les actualiser manuellement (liste en surbrillance).",
                                    "hide-details": "auto",
                                    class: "font-weight-bold",
                                    size: "small"
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ], 16)
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("span", null, [
                                  _createVNode(_component_AccountingPeriodIsDeletable, {
                                    isDeletable: _ctx.accountingPeriod.isDeletable
                                  }, null, 8, ["isDeletable"])
                                ])
                              ]),
                              _: 1
                            }))
                          : (_openBlock(), _createBlock(_component_v_checkbox, {
                              key: 3,
                              dense: "",
                              modelValue: _ctx.isExceptionnalChange,
                              "onUpdate:modelValue": [
                                _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isExceptionnalChange) = $event)),
                                _ctx.checkBoxFunction
                              ],
                              label: "Changement exceptionnel",
                              "hide-details": "auto",
                              size: "small"
                            }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, null, {
                  default: _withCtx(() => [
                    (!_ctx.id && _ctx.accountingPeriods && _ctx.accountingPeriods.length)
                      ? (_openBlock(), _createBlock(_component_v_tooltip, {
                          key: 0,
                          location: "bottom"
                        }, {
                          activator: _withCtx(({ props }) => [
                            _createVNode(_component_v_btn_icon, _mergeProps(props, {
                              size: "large",
                              class: "ml-2",
                              icon: "$oss-help"
                            }), null, 16)
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("template", null, [
                              _cache[46] || (_cache[46] = _createElementVNode("p", null, "Il est possible de créer un nouvel exercice, dans l'ordre :", -1)),
                              _createElementVNode("p", null, " - juste après le dernier existant (après le " + _toDisplayString(_ctx.formatDate(_ctx.accountingPeriods[0].end)) + "), ", 1),
                              (
                                    _ctx.missingAccountingPeriodLaps &&
                                    _ctx.missingAccountingPeriodLaps.length
                                )
                                ? (_openBlock(), _createElementBlock("p", _hoisted_4, " - pour remplir les périodes intermédiaires pour lequelles n'existe pas d'exercice comptable (première disponible : du " + _toDisplayString(_ctx.formatDate(_ctx.missingAccountingPeriodLaps[0].start)) + " au " + _toDisplayString(_ctx.formatDate(_ctx.missingAccountingPeriodLaps[0].end)) + "). ", 1))
                                : _createCommentVNode("", true),
                              _createElementVNode("p", null, " - juste avant le premier existant (avant le " + _toDisplayString(_ctx.formatDate(
                                        _ctx.accountingPeriods[_ctx.accountingPeriods.length - 1].start,
                                    )) + "), ", 1)
                            ])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_v_tabs, {
          modelValue: _ctx.step,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.step) = $event)),
          "fixed-tabs": "",
          style: {"background-color":"transparent !important","border-radius":"16px","overflow":"hidden"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_tab, {
              value: "accPeriod",
              href: "#accPeriod"
            }, {
              default: _withCtx(() => _cache[47] || (_cache[47] = [
                _createElementVNode("strong", null, "Exercice", -1)
              ])),
              _: 1
            }),
            _createVNode(_component_v_tab, {
              value: "accSituation",
              href: "#accSituation",
              disabled: 
                        !_ctx.id ||
                        (_ctx.definitivelyClosed &&
                            _ctx.accountingPeriod &&
                            !(
                                _ctx.accountingPeriod.accountingSituations &&
                                _ctx.accountingPeriod.accountingSituations.length
                            ))
                    ,
              "data-cy": "AccountingPeriod-situation"
            }, {
              default: _withCtx(() => _cache[48] || (_cache[48] = [
                _createElementVNode("strong", null, "Situations", -1)
              ])),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(_component_v_tab, {
              value: "accClosing",
              href: "#accClosing",
              disabled: 
                        !_ctx.id ||
                        (_ctx.definitivelyClosed && !(_ctx.accountingClosings && _ctx.accountingClosings.length))
                    ,
              "data-cy": "AccountingPeriod-cloture"
            }, {
              default: _withCtx(() => _cache[49] || (_cache[49] = [
                _createElementVNode("strong", null, "Clôtures", -1)
              ])),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_v_tabs_window, {
          modelValue: _ctx.step,
          "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.step) = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_window_item, { value: "accPeriod" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_form, {
                  modelValue: _ctx.valid,
                  "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.valid) = $event))
                }, {
                  default: _withCtx(() => [
                    (_ctx.accountingPeriod)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (
                                    _ctx.accountingPeriod.closed ||
                                    _ctx.newClosed ||
                                    (_ctx.accountingClosings && _ctx.accountingClosings.length)
                                )
                            ? (_openBlock(), _createBlock(_component_v_row, {
                                key: 0,
                                "no-gutters": ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, {
                                    cols: "6",
                                    class: "pl-1 pt-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_oss_date_picker_filled, {
                                        modelValue: _ctx.newStartDate,
                                        "onUpdate:modelValue": [
                                          _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newStartDate) = $event)),
                                          _cache[4] || (_cache[4] = 
                                            ($event) => _ctx.$nextTick(() => _ctx.onNewStartChanged($event))
                                        )
                                        ],
                                        textFieldReadOnly: false,
                                        disabled: !_ctx.startDateEditable,
                                        "min-date": _ctx.minStartDate
                                      }, null, 8, ["modelValue", "disabled", "min-date"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, {
                                    cols: "6",
                                    class: "pl-1 pt-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_oss_date_picker_filled, {
                                        modelValue: _ctx.newEndDate,
                                        "onUpdate:modelValue": [
                                          _cache[5] || (_cache[5] = ($event: any) => ((_ctx.newEndDate) = $event)),
                                          _cache[6] || (_cache[6] = 
                                            ($event) => _ctx.$nextTick(() => _ctx.onNewEndChanged($event))
                                        )
                                        ],
                                        textFieldReadOnly: false,
                                        disabled: !_ctx.endDateEditable,
                                        "max-date": _ctx.maxEndDate
                                      }, null, 8, ["modelValue", "disabled", "max-date"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : (
                                    _ctx.accountingPeriod &&
                                    _ctx.accountingPeriod.isDeletable &&
                                    _ctx.accountingPeriod.isDeletable.length
                                )
                              ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                  key: 1,
                                  location: "top"
                                }, {
                                  activator: _withCtx(({ props }) => [
                                    _createElementVNode("div", _mergeProps(props, { class: "pt-2" }), [
                                      _createVNode(_component_v_row, { "no-gutters": "" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_col, {
                                            cols: "6",
                                            class: "pl-1 pt-2"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_oss_date_picker_filled, {
                                                modelValue: _ctx.newStartDate,
                                                "onUpdate:modelValue": [
                                                  _cache[7] || (_cache[7] = ($event: any) => ((_ctx.newStartDate) = $event)),
                                                  _cache[8] || (_cache[8] = 
                                                            ($event) =>
                                                                _ctx.$nextTick(() =>
                                                                    _ctx.onNewStartChanged($event),
                                                                )
                                                        )
                                                ],
                                                textFieldReadOnly: false,
                                                disabled: !_ctx.startDateEditable,
                                                "min-date": _ctx.minStartDate
                                              }, null, 8, ["modelValue", "disabled", "min-date"])
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_v_col, {
                                            cols: "6",
                                            class: "pl-1 pt-2"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_oss_date_picker_filled, {
                                                modelValue: _ctx.newEndDate,
                                                "onUpdate:modelValue": [
                                                  _cache[9] || (_cache[9] = ($event: any) => ((_ctx.newEndDate) = $event)),
                                                  _cache[10] || (_cache[10] = 
                                                            ($event) =>
                                                                _ctx.$nextTick(() =>
                                                                    _ctx.onNewEndChanged($event),
                                                                )
                                                        )
                                                ],
                                                textFieldReadOnly: false,
                                                disabled: !_ctx.endDateEditable,
                                                "max-date": _ctx.maxEndDate
                                              }, null, 8, ["modelValue", "disabled", "max-date"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ], 16)
                                  ]),
                                  default: _withCtx(() => [
                                    _createElementVNode("span", null, [
                                      _createVNode(_component_AccountingPeriodIsDeletable, {
                                        isDeletable: _ctx.accountingPeriod.isDeletable
                                      }, null, 8, ["isDeletable"])
                                    ])
                                  ]),
                                  _: 1
                                }))
                              : (_openBlock(), _createBlock(_component_v_row, {
                                  key: 2,
                                  "no-gutters": ""
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      cols: "6",
                                      class: "pl-1 pt-2"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_oss_date_picker_filled, {
                                          modelValue: _ctx.newStartDate,
                                          "onUpdate:modelValue": [
                                            _cache[11] || (_cache[11] = ($event: any) => ((_ctx.newStartDate) = $event)),
                                            _cache[12] || (_cache[12] = 
                                            ($event) => _ctx.$nextTick(() => _ctx.onNewStartChanged($event))
                                        )
                                          ],
                                          textFieldReadOnly: false,
                                          readonly: _ctx.readOnly,
                                          disabled: !_ctx.startDateEditable,
                                          "min-date": _ctx.minStartDate
                                        }, null, 8, ["modelValue", "readonly", "disabled", "min-date"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, {
                                      cols: "6",
                                      class: "pl-1 pt-2"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_oss_date_picker_filled, {
                                          modelValue: _ctx.newEndDate,
                                          "onUpdate:modelValue": [
                                            _cache[13] || (_cache[13] = ($event: any) => ((_ctx.newEndDate) = $event)),
                                            _cache[14] || (_cache[14] = 
                                            ($event) => _ctx.$nextTick(() => _ctx.onNewEndChanged($event))
                                        )
                                          ],
                                          textFieldReadOnly: false,
                                          readonly: _ctx.readOnly,
                                          disabled: !_ctx.endDateEditable,
                                          "max-date": _ctx.maxEndDate
                                        }, null, 8, ["modelValue", "readonly", "disabled", "max-date"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                        ], 64))
                      : (!_ctx.accountingPeriods || !_ctx.accountingPeriods.length)
                        ? (_openBlock(), _createBlock(_component_v_row, {
                            key: 1,
                            "no-gutters": ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, {
                                cols: "6",
                                class: "pl-1 pt-2"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_oss_date_picker_filled, {
                                    modelValue: _ctx.newStartDate,
                                    "onUpdate:modelValue": [
                                      _cache[15] || (_cache[15] = ($event: any) => ((_ctx.newStartDate) = $event)),
                                      _cache[16] || (_cache[16] = 
                                        ($event) => _ctx.$nextTick(() => _ctx.onNewStartChanged($event))
                                    )
                                    ],
                                    textFieldReadOnly: false,
                                    readonly: _ctx.readOnly,
                                    prefixDataCy: "AccountingPeriod-dateDebut"
                                  }, null, 8, ["modelValue", "readonly"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "6",
                                class: "pl-1 pt-2"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_oss_date_picker_filled, {
                                    modelValue: _ctx.newEndDate,
                                    "onUpdate:modelValue": [
                                      _cache[17] || (_cache[17] = ($event: any) => ((_ctx.newEndDate) = $event)),
                                      _cache[18] || (_cache[18] = 
                                        ($event) => _ctx.$nextTick(() => _ctx.onNewEndChanged($event))
                                    )
                                    ],
                                    textFieldReadOnly: false,
                                    readonly: _ctx.readOnly,
                                    prefixDataCy: "AccountingPeriod-dateFin"
                                  }, null, 8, ["modelValue", "readonly"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_v_row, {
                            key: 2,
                            "no-gutters": ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, {
                                cols: "6",
                                class: "pl-1 pt-2"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_oss_date_picker_filled, {
                                    modelValue: _ctx.newStartDate,
                                    "onUpdate:modelValue": [
                                      _cache[19] || (_cache[19] = ($event: any) => ((_ctx.newStartDate) = $event)),
                                      _cache[20] || (_cache[20] = 
                                        ($event) => _ctx.$nextTick(() => _ctx.onNewStartChanged($event))
                                    )
                                    ],
                                    textFieldReadOnly: false,
                                    readonly: _ctx.readOnly,
                                    disabled: !_ctx.startDateEditable,
                                    "min-date": _ctx.minStartDate,
                                    prefixDataCy: "AccountingPeriod-dateDebut"
                                  }, null, 8, ["modelValue", "readonly", "disabled", "min-date"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "6",
                                class: "pl-1 pt-2"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_oss_date_picker_filled, {
                                    modelValue: _ctx.newEndDate,
                                    "onUpdate:modelValue": [
                                      _cache[21] || (_cache[21] = ($event: any) => ((_ctx.newEndDate) = $event)),
                                      _cache[22] || (_cache[22] = 
                                        ($event) => _ctx.$nextTick(() => _ctx.onNewEndChanged($event))
                                    )
                                    ],
                                    textFieldReadOnly: false,
                                    readonly: _ctx.readOnly,
                                    disabled: !_ctx.endDateEditable,
                                    "max-date": _ctx.maxEndDate,
                                    prefixDataCy: "AccountingPeriod-dateFin"
                                  }, null, 8, ["modelValue", "readonly", "disabled", "max-date"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })),
                    (_ctx.stepData && _ctx.stepData.action)
                      ? (_openBlock(), _createBlock(_component_v_row, {
                          key: 3,
                          "no-gutters": "",
                          class: "my-2"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("h4", _hoisted_5, _toDisplayString(_ctx.stepData.title !== "XXX" || "Clôture de l'exercice"), 1),
                            _createVNode(_component_v_progress_linear, {
                              color: "secondary",
                              height: "10",
                              "buffer-value": "0",
                              stream: "",
                              class: "ml-2",
                              "model-value": _ctx.stepData.progressValue
                            }, null, 8, ["model-value"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_spacer),
                        _createVNode(_component_v_col, { class: "d-flex justify-end" }, {
                          default: _withCtx(() => [
                            (_ctx.carryForwardIsBlocked && _ctx.deleteCarryForwardBtnText)
                              ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                  key: 0,
                                  class: "pt-4 px-4",
                                  location: "bottom"
                                }, {
                                  activator: _withCtx(({ props }) => [
                                    _createElementVNode("div", _mergeProps({ style: {"height":"fit-content"} }, props), [
                                      _createVNode(_component_v_btn, {
                                        color: "red",
                                        rounded: "",
                                        elevation: "0",
                                        disabled: "",
                                        size: "small"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.deleteCarryForwardBtnText), 1)
                                        ]),
                                        _: 1
                                      })
                                    ], 16)
                                  ]),
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.carryForwardTooltipMessage, (line) => {
                                      return (_openBlock(), _createElementBlock("h4", null, _toDisplayString(line), 1))
                                    }), 256))
                                  ]),
                                  _: 1
                                }))
                              : (_ctx.deleteCarryForwardBtnText)
                                ? (_openBlock(), _createBlock(_component_v_btn, {
                                    key: 1,
                                    color: "red",
                                    rounded: "",
                                    elevation: "0",
                                    onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.deleteCarryForward())),
                                    loading: _ctx.deleteCarryForwardLoading,
                                    size: "small"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.deleteCarryForwardBtnText), 1)
                                    ]),
                                    _: 1
                                  }, 8, ["loading"]))
                                : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { class: "d-flex justify-end pl-2" }, {
                          default: _withCtx(() => [
                            (_ctx.carryForwardIsBlocked && _ctx.computeCarryForwardBtnText)
                              ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                  key: 0,
                                  class: "pt-4 px-4",
                                  location: "bottom"
                                }, {
                                  activator: _withCtx(({ props }) => [
                                    _createElementVNode("div", _mergeProps({ style: {"height":"fit-content"} }, props), [
                                      _createVNode(_component_v_btn, {
                                        rounded: "",
                                        elevation: "0",
                                        disabled: "",
                                        size: "small"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.computeCarryForwardBtnText), 1)
                                        ]),
                                        _: 1
                                      })
                                    ], 16)
                                  ]),
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.carryForwardTooltipMessage, (line) => {
                                      return (_openBlock(), _createElementBlock("h4", null, _toDisplayString(line), 1))
                                    }), 256))
                                  ]),
                                  _: 1
                                }))
                              : (_ctx.computeCarryForwardBtnText)
                                ? (_openBlock(), _createBlock(_component_v_btn, {
                                    key: 1,
                                    rounded: "",
                                    elevation: "0",
                                    onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.computeCarryForward())),
                                    loading: _ctx.computeCarryForwardLoading,
                                    disabled: _ctx.readOnly,
                                    size: "small"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.computeCarryForwardBtnText), 1)
                                    ]),
                                    _: 1
                                  }, 8, ["loading", "disabled"]))
                                : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        (!_ctx.definitivelyClosed && !!_ctx.id)
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 0,
                              class: "d-flex justify-end pl-2"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn, {
                                  rounded: "",
                                  elevation: "0",
                                  onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.openConfirmDialog())),
                                  disabled: _ctx.readOnly,
                                  "data-cy": "AccountingPeriod-clos1",
                                  size: "small"
                                }, {
                                  default: _withCtx(() => _cache[50] || (_cache[50] = [
                                    _createTextVNode("Clôturer l'exercice")
                                  ])),
                                  _: 1
                                }, 8, ["disabled"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.definitivelyClosed && !!_ctx.id)
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 1,
                              class: "d-flex justify-end pl-2"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn, {
                                  rounded: "",
                                  elevation: "0",
                                  onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.openReopenDialog())),
                                  disabled: _ctx.readOnly,
                                  "data-cy": "AccountingPeriod-open",
                                  size: "small"
                                }, {
                                  default: _withCtx(() => _cache[51] || (_cache[51] = [
                                    _createTextVNode("Réouvrir l'exercice")
                                  ])),
                                  _: 1
                                }, 8, ["disabled"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_window_item, { value: "accSituation" }, {
              default: _withCtx(() => [
                (
                            _ctx.accountingPeriod &&
                            _ctx.accountingPeriod.accountingSituations &&
                            _ctx.accountingPeriod.accountingSituations.length
                        )
                  ? (_openBlock(), _createBlock(_component_v_list, {
                      key: 0,
                      "single-line": "",
                      class: "pt-0",
                      density: "compact"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accountingPeriod.accountingSituations, (as, asi) => {
                          return (_openBlock(), _createBlock(_component_v_list_item, {
                            ripple: false,
                            class: "mb-2",
                            color: "success",
                            key: asi
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, { class: "body-1" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, {
                                    class: "d-flex align-center",
                                    "no-gutters": ""
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, { cols: "9" }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_6, [
                                            _createElementVNode("span", {
                                              class: _normalizeClass(_ctx.$vuetify.display.mobile ? 'ml-2' : ''),
                                              style: {"font-weight":"bold"}
                                            }, _toDisplayString(_ctx.situationTitle(as)), 3)
                                          ])
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_v_col, {
                                        cols: "1",
                                        class: "d-flex justify-center align-center"
                                      }, {
                                        default: _withCtx(() => [
                                          (!as.closed)
                                            ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                                                key: 0,
                                                icon: "$edit",
                                                onClick: ($event: any) => (_ctx.setAccountingSituationToUpsert(as))
                                              }, null, 8, ["onClick"]))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_v_col, {
                                        cols: "1",
                                        class: "d-flex justify-center align-center"
                                      }, {
                                        default: _withCtx(() => [
                                          (as.closed)
                                            ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                                                key: 0,
                                                icon: "$lock_outline"
                                              }))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_v_col, {
                                        cols: "1",
                                        class: "d-flex justify-center align-center"
                                      }, {
                                        default: _withCtx(() => [
                                          (_ctx.isAuthorized)
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                (
                                                    _ctx.accountingSituationIsDeletable(
                                                        _ctx.accountingPeriod,
                                                        as,
                                                    )
                                                )
                                                  ? (_openBlock(), _createBlock(_component_v_btn_trash, {
                                                      key: 0,
                                                      onClick: ($event: any) => (_ctx.openDeleteAccountingSituationDialog(as)),
                                                      "data-cy": 'AccountingSituation-trash-' + as.id
                                                    }, null, 8, ["onClick", "data-cy"]))
                                                  : (_openBlock(), _createBlock(_component_v_tooltip, {
                                                      key: 1,
                                                      location: "bottom"
                                                    }, {
                                                      activator: _withCtx(({ props }) => [
                                                        _createElementVNode("div", null, [
                                                          _createVNode(_component_v_btn_trash, _mergeProps({
                                                            disabled: "",
                                                            ref_for: true
                                                          }, props), null, 16)
                                                        ])
                                                      ]),
                                                      default: _withCtx(() => [
                                                        _createElementVNode("span", null, [
                                                          _createVNode(_component_AccountingPeriodIsDeletable, {
                                                            isDeletable: as.isDeletable
                                                          }, null, 8, ["isDeletable"])
                                                        ])
                                                      ]),
                                                      _: 2
                                                    }, 1024))
                                              ], 64))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_row, {
                  "no-gutters": "",
                  class: "d-flex justify-center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "4",
                      class: "pa-2 d-flex justify-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn_primary, {
                          block: "",
                          disabled: _ctx.definitivelyClosed || _ctx.readOnly,
                          onClick: _cache[28] || (_cache[28] = ($event: any) => {
                                    _ctx.accountingSituationToUpsert =
                                        _ctx.defaultAccountingSituationToUpsert();
                                    _ctx.upsertAccountingSituationDialog = true;
                                }),
                          "data-cy": "AccountingPeriod-addSituation"
                        }, {
                          default: _withCtx(() => _cache[52] || (_cache[52] = [
                            _createTextVNode(" Ajouter ")
                          ])),
                          _: 1
                        }, 8, ["disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_window_item, { value: "accClosing" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, {
                  "no-gutters": "",
                  class: "d-flex justify-center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "12",
                      class: "pa-2"
                    }, {
                      default: _withCtx(() => [
                        (_ctx.accountingClosings && _ctx.accountingClosings.length)
                          ? (_openBlock(), _createBlock(_component_v_list, {
                              key: 0,
                              "single-line": "",
                              class: "pt-0",
                              density: "compact"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accountingClosings, (ac, aci) => {
                                  return (_openBlock(), _createBlock(_component_v_list_item, {
                                    ripple: false,
                                    class: "mb-2",
                                    color: "success",
                                    key: aci
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list_item_title, { class: "body-1" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_row, {
                                            class: "d-flex align-center",
                                            "no-gutters": ""
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_col, { cols: "9" }, {
                                                default: _withCtx(() => [
                                                  _createElementVNode("div", _hoisted_7, [
                                                    _createElementVNode("span", {
                                                      class: _normalizeClass(
                                                            _ctx.$vuetify.display.mobile ? 'ml-2' : ''
                                                        ),
                                                      style: {"font-weight":"bold"}
                                                    }, _toDisplayString(_ctx.closingTitle(ac)), 3)
                                                  ])
                                                ]),
                                                _: 2
                                              }, 1024),
                                              _createVNode(_component_v_col, {
                                                cols: "1",
                                                class: "d-flex justify-center align-center"
                                              }),
                                              _createVNode(_component_v_col, {
                                                cols: "1",
                                                class: "d-flex justify-center align-center"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_btn_icon, { icon: "$lock_outline" })
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_component_v_col, {
                                                cols: "1",
                                                class: "d-flex justify-center align-center"
                                              }, {
                                                default: _withCtx(() => [
                                                  (
                                                        _ctx.accountingClosings &&
                                                        _ctx.accountingClosings.length &&
                                                        aci === _ctx.accountingClosings.length - 1 &&
                                                        !_ctx.definitivelyClosed
                                                    )
                                                    ? (_openBlock(), _createBlock(_component_v_btn_trash, {
                                                        key: 0,
                                                        onClick: ($event: any) => (_ctx.deleteAccountingClosing(ac.id)),
                                                        loading: _ctx.deleteAccountingClosingLoading,
                                                        disabled: _ctx.readOnly
                                                      }, null, 8, ["onClick", "loading", "disabled"]))
                                                    : _createCommentVNode("", true)
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128))
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "4",
                      class: "pa-2 d-flex justify-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn_primary, {
                          block: "",
                          disabled: _ctx.definitivelyClosed || _ctx.readOnly,
                          onClick: _cache[29] || (_cache[29] = ($event: any) => {
                                    _ctx.accountingClosingToUpsert = _ctx.defaultAccountingClosingToUpsert();
                                    _ctx.upsertAccountingClosingDialog = true;
                                }),
                          "data-cy": "AccountingPeriod-addSituation"
                        }, {
                          default: _withCtx(() => _cache[53] || (_cache[53] = [
                            _createTextVNode(" Ajouter ")
                          ])),
                          _: 1
                        }, 8, ["disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue", "title", "validLoading", "validDisabled", "validTitle", "hide-valid"]),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.closingDialog,
      "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.closingDialog) = $event)),
      title: "Confirmation",
      onValid: _ctx.closeAccountingPeriod,
      validTitle: "Clôturer",
      validLoading: _ctx.closingLoading,
      prefixDataCy: "AccountingPeriod-closePeriod",
      width: "800px"
    }, {
      default: _withCtx(() => [
        ((!_ctx.stepData || !_ctx.stepData.action) && !_ctx.displayProgressLine)
          ? (_openBlock(), _createBlock(_component_v_row, {
              key: 0,
              "no-gutters": ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => _cache[54] || (_cache[54] = [
                    _createElementVNode("h4", { class: "text-center" }, " Êtes-vous sûr(e) de vouloir clôturer cet exercice comptable ? ", -1)
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_v_row, {
              key: 1,
              "no-gutters": "",
              class: "my-2"
            }, {
              default: _withCtx(() => [
                _createElementVNode("h4", _hoisted_8, _toDisplayString(_ctx.stepData.title), 1),
                _createVNode(_component_v_progress_linear, {
                  color: "secondary",
                  height: "10",
                  "buffer-value": "0",
                  stream: "",
                  class: "ml-2",
                  "model-value": _ctx.stepData.progressValue
                }, null, 8, ["model-value"])
              ]),
              _: 1
            }))
      ]),
      _: 1
    }, 8, ["modelValue", "onValid", "validLoading"]),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.reopenDialog,
      "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.reopenDialog) = $event)),
      title: "Confirmation",
      onValid: _ctx.reopenAccountingPeriod,
      validTitle: "Réouvrir l'exercice",
      validLoading: _ctx.reopenLoading,
      prefixDataCy: "AccountingPeriod-valid",
      width: "800px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, { "no-gutters": "" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "12" }, {
              default: _withCtx(() => _cache[55] || (_cache[55] = [
                _createElementVNode("h4", { class: "text-center" }, " Êtes-vous sûr(e) de vouloir réouvrir cet exercice comptable ? ", -1)
              ])),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "onValid", "validLoading"]),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.upsertAccountingClosingDialog,
      "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.upsertAccountingClosingDialog) = $event)),
      title: _ctx.accountingClosingToUpsert.id ? 'Modifier cette clôture' : 'Créer une clôture',
      onValid: _cache[39] || (_cache[39] = ($event: any) => (_ctx.upsertAccountingClosing())),
      loading: _ctx.upsertAccountingClosingLoading,
      validDisabled: !_ctx.isUpsertClosingDialogValid || !!_ctx.accountingClosingToUpsert.id,
      validTitle: _ctx.accountingClosingToUpsert.id ? 'Modifier' : 'Créer',
      prefixDataCy: "AccountingPeriod-create",
      width: "800px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_form, {
          modelValue: _ctx.isUpsertClosingDialogValid,
          "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.isUpsertClosingDialogValid) = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, { "no-gutters": "" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field_filled, {
                      modelValue: _ctx.accountingClosingToUpsert.name,
                      "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.accountingClosingToUpsert.name) = $event)),
                      label: "Nom",
                      rules: [_ctx.rules.notEmpty],
                      outlined: "",
                      "data-cy": "AccountingPeriod-name",
                      density: "compact"
                    }, null, 8, ["modelValue", "rules"]),
                    _createVNode(_component_v_select_filled, {
                      modelValue: _ctx.accountingClosingToUpsert.endDate,
                      "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.accountingClosingToUpsert.endDate) = $event)),
                      items: _ctx.endDates,
                      "item-value": "value",
                      label: "Date de fin de la situation",
                      rules: [_ctx.rules.notEmpty],
                      elevation: "0",
                      outlined: "",
                      "hide-details": "",
                      disabled: !!_ctx.accountingClosingToUpsert.id,
                      "data-cy": "AccountingPeriod-dateEndCloture",
                      density: "compact"
                    }, null, 8, ["modelValue", "items", "rules", "disabled"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue", "title", "loading", "validDisabled", "validTitle"]),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.upsertAccountingSituationDialog,
      "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.upsertAccountingSituationDialog) = $event)),
      title: 
                _ctx.accountingSituationToUpsert.id ? 'Modifier cette situation' : 'Créer une situation'
            ,
      onValid: _cache[43] || (_cache[43] = ($event: any) => (_ctx.upsertAccountingSituation())),
      loading: _ctx.upsertAccountingSituationLoading,
      validDisabled: !_ctx.isUpsertSituationDialogValid,
      validTitle: _ctx.accountingSituationToUpsert.id ? 'Modifier' : 'Créer',
      prefixDataCy: "AccountingPeriod-create",
      width: "800px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_form, {
          modelValue: _ctx.isUpsertSituationDialogValid,
          "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.isUpsertSituationDialogValid) = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, { "no-gutters": "" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_select_filled, {
                      modelValue: _ctx.accountingSituationToUpsert.endDate,
                      "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.accountingSituationToUpsert.endDate) = $event)),
                      items: _ctx.endDates,
                      "item-value": "value",
                      label: "Date de fin de la situation",
                      rules: [_ctx.rules.notEmpty],
                      elevation: "0",
                      outlined: "",
                      "hide-details": "",
                      "data-cy": "AccountingPeriod-dateEndSituation",
                      density: "compact"
                    }, null, 8, ["modelValue", "items", "rules"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue", "title", "loading", "validDisabled", "validTitle"]),
    (_ctx.selectedAccountingSituation)
      ? (_openBlock(), _createBlock(_component_oss_dialog, {
          key: 0,
          modelValue: _ctx.deleteAccountingSituationDialog,
          "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.deleteAccountingSituationDialog) = $event)),
          error: true,
          validTitle: `Supprimer la situation`,
          onValid: _cache[45] || (_cache[45] = ($event: any) => (_ctx.deleteAccountingSituation(_ctx.selectedAccountingSituation))),
          loading: _ctx.deleteAccountingSituationLoading,
          prefixDataCy: "ossFilterBar-delete",
          width: "800px"
        }, {
          default: _withCtx(() => [
            _cache[56] || (_cache[56] = _createElementVNode("h2", { class: "text-center" }, "Êtes-vous sûr(e) de vouloir supprimer la situation", -1)),
            _createElementVNode("h2", _hoisted_9, " du " + _toDisplayString(_ctx.formatDate(_ctx.selectedAccountingSituation.start)) + " au " + _toDisplayString(_ctx.formatDate(_ctx.selectedAccountingSituation.end)) + " ? ", 1)
          ]),
          _: 1
        }, 8, ["modelValue", "loading"]))
      : _createCommentVNode("", true)
  ]))
}